import React from 'react';
import './IndexPage.css'; // We'll create this CSS file next
import logo from '../assets/logo_nbg.png';

const IndexPage = () => {
  return (
    <div className="index-page-container">
      <img src={logo} alt="ProCheck Logo" className="index-page-logo" />
      <h1>Willkommen bei ProCheck - deiner Ausrüstungsverwaltung</h1>
      <p>
        Mit ProCheck verwaltest du deine persönliche Ausrüstung sowie das Equipment von Organisationen wie Bergrettung oder Bergführern zentral und effizient. Rechts oben wählst du über das Dropdown deine Gruppe aus. Standardmäßig siehst du dort dein privates Equipment. Wenn du Mitglied weiterer Organisationen bist und diese dich zu ihrer Gruppe hinzugefügt haben, erscheinen auch diese zur Auswahl.
      </p>
      <p>
        Im Bereich Ausrüstung kannst du beliebig viele Container anlegen - etwa Rucksäcke, Fahrzeuge oder Depots - und darin deine Ausrüstungsgegenstände verwalten.
      </p>
      <p>
        Unter Prüfung führst du regelmäßige Ausrüstungsprüfungen durch und dokumentierst sie lückenlos. ProCheck zeigt dir, wann welche Items zur Prüfung fällig sind. Du kannst auch mehrere Ausrüstungsteile markieren und eine Sammelprüfung durchführen.
      </p>
    </div>
  );
};

export default IndexPage;